import { ContactCta } from './ContactCta';

export type { TypeContactCtaProps } from './types';

export default ContactCta;
export { ContactCta };
